import React from 'react';
import { Button } from '@/shared/ui/button';
import { Input } from '@/shared/ui/input';
import { Label } from '@/shared/ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/shared/ui/dialog';
import { Photo } from '../types/types';

interface AreaFormDialogProps {
  open: boolean;
  areaName: string;
  selectedPhotos: number[];
  availablePhotos: Photo[];
  onOpenChange: (open: boolean) => void;
  onAreaNameChange: (name: string) => void;
  onSelectedPhotosChange: (photoIds: number[]) => void;
  onSave: () => void;
  onCancel: () => void;
}

export const AreaFormDialog: React.FC<AreaFormDialogProps> = ({
  open,
  areaName,
  selectedPhotos,
  availablePhotos,
  onOpenChange,
  onAreaNameChange,
  onSelectedPhotosChange,
  onSave,
  onCancel,
}) => {
  const handlePhotosChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const values = Array.from(e.target.selectedOptions, (option) =>
      parseInt(option.value)
    );
    onSelectedPhotosChange(values);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add Area</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="areaName">Area Name</Label>
            <Input
              id="areaName"
              value={areaName}
              onChange={(e) => onAreaNameChange(e.target.value)}
              placeholder="Enter area name..."
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="relatedPhotos">Related Photos</Label>
            <select
              id="relatedPhotos"
              multiple
              value={selectedPhotos.map(String)}
              onChange={handlePhotosChange}
              className="w-full h-32 px-3 py-2 border border-border rounded-lg bg-input text-foreground focus:ring-2 focus:ring-ring focus:border-ring outline-none"
            >
              {availablePhotos.map((photo) => (
                <option key={photo.id} value={photo.id}>
                  {photo.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button onClick={onSave}>Save Area</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}; 